import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  template: '<router-outlet></router-outlet>'
})
export class FullLayoutComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/layouts/full-layout.component.ts